/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon16Solid = forwardRef('DataChartPieA2Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 1a7 7 0 1 0 7 7H9a1 1 0 0 1-1-1V1Z" }),
        React.createElement("path", { d: "M9 1.07A7.004 7.004 0 0 1 14.93 7H9V1.07Z" })));
});
